// Bildschirm einrichten in der Eltern-App, auf Deutsch (siehe boardConfigApp.nl.ts).
export const appBoardConfigDe = {
    open: 'Bildschirm einrichten',
    title: 'Bildschirm einrichten',
    intro: 'Verschiebe die Widgets im Raster und mach sie schmaler, breiter, niedriger oder höher: Je größer, desto mehr zeigen sie. Eine Tafel hat bis zu 12 Seiten; auf der Tafel wischst du zur Seite zur nächsten.',
    standard: 'Diese Tafel zeigt den Standard. Ändere etwas für deine eigene Einteilung.',
    onBoard: 'Auf der Tafel',
    available: 'Hinzufügen',
    nothingToAdd: 'Alle Widgets eurer Module sind schon drauf.',
    empty: 'Noch nichts auf dieser Seite. Füge unten etwas hinzu.',
    size: 'Größe',
    style: 'Gestaltung',
    moveUp: '{name} nach oben',
    moveDown: '{name} nach unten',
    remove: '{name} entfernen',
    pageEarlier: '{name} nach vorne',
    pageLater: '{name} nach hinten',
    pageRemove: '{name} entfernen',
    onPage: 'Auf {name}',
    weekSketch: 'Kalender der Woche',
    phoneHint: 'Verschieben und Größe ändern geht auf einem Tablet oder Computer. Hier wählst du, was auf jeder Seite steht.',
    add: '{name} hinzufügen',
    reset: 'Standardeinteilung',
    save: 'Speichern',
    saved: 'Gespeichert. Die Tafel passt sich innerhalb einer Minute an.',
    resetDone: 'Die Standardeinteilung ist bereit. Speichere, um sie auf die Tafel zu bringen.',
    failed: 'Speichern hat nicht geklappt. Versuche es gleich noch einmal.',
    conflict: 'Diese Tafel wurde inzwischen geändert, vielleicht auf der Tafel selbst. Jetzt steht die neueste Einteilung da.',
    preview: 'Vorschau',
    previewNote: 'Mit Beispieldaten; die Tafel nutzt eure.',
    screen: 'Bildschirm',
    screens: { large: 'iPad', wide: 'Breites Tablet', compact: 'Kleines Tablet' },
    gestureTitle: 'Auf der Tafel selbst anpassen',
    gestureBody: 'Tippe dreimal schnell auf die Uhr der Tafel und gib deine Eltern-PIN ein. Nach einer Minute ohne Tippen schließt es sich von selbst.',
    pinTitle: 'Meine Eltern-PIN',
    pinBody: 'Verwende deine eigene PIN. Jeder Elternteil hat eine persönliche PIN.',
    pinLabel: 'Neue Eltern-PIN',
    pinSave: 'PIN speichern',
    pinSaved: 'Deine Eltern-PIN ist gespeichert.',
    pinInvalid: 'Wähle 4 bis 6 Ziffern.',
    pinTaken: 'Diese PIN verwendet schon ein anderes Elternteil. Wähle eine andere.',
    back: 'Zurück zu Tablets',
    names: {
        prayer: 'Gebetszeiten',
        weather: 'Wetter',
        tasks: 'Aufgaben',
        rides: 'Bringen und Abholen',
        meals: 'Essen',
        upcoming: 'Demnächst',
        messages: 'Nachrichten',
        memorize: 'Suren lernen',
        dinner: 'Wer isst mit',
        bookings: 'Reservieren',
        precip: 'Niederschlag',
        week: 'Woche (Min. und Max.)',
        quran: 'Koran hören',
        todos: 'To-dos',
        notes: 'Notizen',
        // 0068: Gezond op gewicht.
        kompas: 'Gesund unterwegs (Gesundes Gewicht)',
        // 0076: schoolplanner (nooit een cijfer op het bord).
        school: 'Schule (Hausaufgaben und Arbeiten)',
        // 0062: module Jodendom.
        shabbat: 'Schabbat und Kalender',
        // 0061: Kerk & kalender.
        seasons: 'Kirche & Kalender',
        // 0063: module Hindoeïsme.
        almanac: 'Panchang und Feste',
        // UX-ronde bord: Boodschappen (module Eten) en Beloningen.
        groceries: 'Einkaufsliste',
        rewards: 'Belohnungen',
        // 0075: Huisronde (module Eten).
        house_round: 'Hausrundgang',
        // Widgets compleet: Wensen, Foto (Fotolijst), Timer, Schoonmaak en Beurtrooster.
        wishes: 'Wünsche',
        photo: 'Foto (Fotorahmen)',
        timer: 'Timer',
        cleaning: 'Putzen',
        rotation: 'Dienstplan',
        // Widgets privé (0077): de gewone nieuwe widgets en de privé-widgets.
        clock: 'Uhr',
        travel: 'Abfahrt',
        stock: 'Vorrat',
        cookbook: 'Kochbuch',
        reminders: 'Erinnerungen',
        checkin: 'Check-in',
        fasting: 'Fasten',
        growth: 'Wachstum',
        money: 'Geldsachen',
        expenses: 'Kosten teilen',
        my_todos: 'Private To-dos',
        circle: 'Familienkreis',
    },
    sizes: { S: 'Klein', M: 'Mittel', L: 'Groß', XL: 'Extra groß' },
    sizeHints: {
        S: 'Das Wichtigste auf einen Blick',
        M: 'Heute',
        L: 'Heute und morgen, ausführlicher',
        XL: 'Alles, auf einem breiten Bildschirm',
    },
    /** Fijnslijpen ouderapp: Brengen en halen, de ophaaltijd als schakelaar (stijl list of no_pickup). */
    ridesPickup: 'Abholzeit zeigen',
    ridesPickupHint: 'Zum Beispiel "Papa holt ab 16:50". Aus: nur wer abholt.',
    styles: {
        // Widget Foto.
        slideshow: 'Wechselt jede Minute',
        daily: 'Foto des Tages',
        no_pickup: 'Ohne Abholzeit',
        list: 'Liste',
        ring: 'Uhr',
        compact: 'Kompakt',
        illustrated: 'Mit Bild',
        today: 'Nur heute',
        bars: 'Balken',
    },
    /** Koran luisteren: "Over de opnames" bij de widget. */
    quran: {
        aboutTitle: 'Über die Aufnahmen',
        aboutBody: 'Rezitation von {name}. Quelle: {source}.',
        familyOnly: 'Es ist keine Lizenz bekannt: Diese Aufnahmen sind nur für eure Familie.',
        none: 'Noch keine Aufnahmen für eure Familie.',
    },
    /** Voorbeeldgezin in het voorbeeld van "Scherm inrichten" (kiosk-ui widgets/sample.ts). */
    samples: {
        // Widgets compleet: wensen, klussen en een bijschrift van het voorbeeldgezin.
        wishLego: 'Lego-Raumschiff',
        wishBook: 'Tierbuch',
        wishSkates: 'Inlineskates',
        choreBathroom: 'Badezimmer',
        choreVacuum: 'Staubsaugen',
        choreBins: 'Müll rausbringen',
        photoCaption: 'Sommer am Meer',
        school: 'Schule',
        swimming: 'Schwimmkurs',
        judo: 'Judo',
        brushTeeth: 'Zähne putzen',
        packBag: 'Tasche packen',
        makeBed: 'Bett machen',
        setTable: 'Tisch decken',
        groceries: 'Einkaufen',
        birthday: 'Noor wird 8',
        autumnBreak: 'Herbstferien',
        pasta: 'Pasta Pesto',
        soup: 'Suppe',
        curry: 'Curry',
        pancakes: 'Pfannkuchen',
        pizza: 'Pizza',
        stew: 'Eintopf',
        inHours: '{n} Std.',
        paintCupboard: 'Schuhschrank streichen',
        fixBike: 'Fahrradreifen flicken',
        clearGutter: 'Dachrinne reinigen',
        noteMilk: 'Milch ist alle',
        noteSwim: 'Schwimmtasche nicht vergessen',
        // UX-ronde bord: voorbeeld voor de widgets Boodschappen en Beloningen.
        milk: 'Milch',
        bread: 'Brot',
        apples: 'Äpfel',
        cheese: 'Käse',
        cinema: 'Kino',
    },
};
//# sourceMappingURL=boardConfigApp.de.js.map